export const select_company = `Select Company`
export const select_branch = `Select Company Branch`
export const from_collection_date = `From Collection Date`
export const to_collection_date = `To Collection Date`
export const summary = `Summary`
export const detailed = `Detailed`
export const fromDate = `From Collection Date`
export const destination = `Destination City`
export const destinationBranch = `Destination Branch`
export const onlyRefund = `Only Refund`
export const dispatchByBranch = `Dispatch By Branch`
export const vehicle = `Vehicle Number`
export const paymentType = `Payment Type`
export const fromBookingDate = `From Booking Date`
export const toBookingDate = `To Booking Date`
export const user = `User`
export const franchiseCompany = `Franchise Company`
export const franchiseBranch = `Franchise Branch`
export const financialYear = `Financial Year`
export const showTransaction = 'Show Transaction'
//QuickView Report
export const from_booking_date = `From Booking Date`
export const to_booking_date = `To Booking Date`
export const branchWise = `Branchwise`

export const cancelDispatch = `Cancel Dispatch`

export const booking_date_wise = 'Booking Date Wise'

export const from_dispatch_date = `From Dispatch Date`
export const to_dispatch_date = `To Dispatch Date`
export const selectBranch = `Select Branch`
export const selectCity = `Select City`
export const selectState = `Select State`

export const transactionType = 'Transaction Type'
export const reportView = `Report View`
export const SelectDays = `Select Days`
export const ReportOptions = 'Report Options'
export const crossingTransactions = 'Crossing Transactions'
export const LRStatus = 'LR Status'

export const franchiseeCompany='Select Franchisee Company'
export const OwnBookingCity='Own Booking City'
export const OwnBookingBranch='Own Booking Branch'
export const OwnBkgBranchUser='Own Booking Branch User'
export const PaymentMode='Payment Mode'
